// extracted by mini-css-extract-plugin
export default {"container":"style_container__YvaNl","card":"style_card__xvNRM","row":"style_row__1Bzkv","btnsRow":"style_btnsRow__ulTuy"};